<script setup>
import { ref, onMounted, watchEffect } from "vue";
import Feed from "../components/Feed";
import FilterBarEvent from "../components/FilterBarEvent";
import FilterBarPost from "../components/FilterBarPost";
import LoadingSpinner from "../components/LoadingSpinner.vue";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const store = useFilteredFeedStore();

onMounted(async () => {
	store.filters = await store.initState();
	store.fetchItems();

	// watchEffect(() => {
	// 	store.fetchItems();
	// });
});
</script>
<template>
	<section>
		<FilterBarEvent v-if="store.endpoint === 'event'" />
		<FilterBarPost v-if="store.endpoint === 'post'" />

		<section class="w-full gs-y" :class="store.endpoint === 'event' ? 'bg-umf-gradient-y' : ''">
			<div class="gs-x">
				<div class="xl:container mx-auto min-h-screen">
					<p class="typo-body-md" aria-live="polite" v-show="!store.items.length && !store.isLoading">
						Sorry no results, <a @click.prevent="store.clearFilters()" href="#" class="underline">clear filters</a>?
					</p>
					<p v-if="store.isLoading" class="typo-body-md hidden motion-reduce:block">Loading</p>
					<LoadingSpinner v-if="store.isLoading" class="motion-reduce:hidden mb-8 text-purple" />
					<Feed v-show="store.items.length && !store.isLoading" :items="store.items" />
				</div>
			</div>
		</section>
	</section>
</template>
